export default __webpack_public_path__ + "static/media/leo.7cfaab22.svg";